import { IDSCHOOL_URL } from '../types/content';

const CHANNEL = 'idcoder-sso';
export const SSO_TOKEN_EVENT = 'idcoder-sso-token';

export function siblingOrigin(): string {
  return IDSCHOOL_URL.replace(/\/$/, '');
}

let listenerInstalled = false;

export function installSsoListener(): void {
  if (listenerInstalled || typeof window === 'undefined') {
    return;
  }
  listenerInstalled = true;

  window.addEventListener('message', (event: MessageEvent) => {
    if (event.origin !== siblingOrigin()) {
      return;
    }
    const data = event.data as { channel?: string; action?: string; token?: string } | null;
    if (!data || data.channel !== CHANNEL) {
      return;
    }

    const source = event.source as Window | null;
    if (data.action === 'get-token') {
      source?.postMessage(
        { channel: CHANNEL, action: 'token', token: localStorage.getItem('token') },
        event.origin
      );
      return;
    }

    if (data.action === 'set-token' && typeof data.token === 'string' && data.token) {
      localStorage.setItem('token', data.token);
      window.dispatchEvent(new Event(SSO_TOKEN_EVENT));
      return;
    }

    if (data.action === 'clear-token') {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event(SSO_TOKEN_EVENT));
    }
  });
}

export function requestTokenFromOpener(): Promise<string | null> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || !window.opener || window.opener.closed) {
      resolve(null);
      return;
    }

    const origin = siblingOrigin();
    const timer = window.setTimeout(() => {
      window.removeEventListener('message', onMessage);
      resolve(null);
    }, 800);

    function onMessage(event: MessageEvent) {
      if (event.origin !== origin) {
        return;
      }
      const data = event.data as { channel?: string; action?: string; token?: unknown } | null;
      if (!data || data.channel !== CHANNEL || data.action !== 'token') {
        return;
      }
      window.clearTimeout(timer);
      window.removeEventListener('message', onMessage);
      resolve(typeof data.token === 'string' && data.token ? data.token : null);
    }

    window.addEventListener('message', onMessage);
    try {
      window.opener.postMessage({ channel: CHANNEL, action: 'get-token' }, origin);
    } catch {
      window.clearTimeout(timer);
      window.removeEventListener('message', onMessage);
      resolve(null);
    }
  });
}

export function notifySiblingAuth(token: string | null): void {
  if (typeof window === 'undefined') {
    return;
  }
  const origin = siblingOrigin();
  const payload = token
    ? { channel: CHANNEL, action: 'set-token', token }
    : { channel: CHANNEL, action: 'clear-token' };
  try {
    window.opener?.postMessage(payload, origin);
  } catch {
    // Opener may be closed or a different origin.
  }
}

export function writeLocalToken(token: string): void {
  localStorage.setItem('token', token);
  notifySiblingAuth(token);
}

export function clearLocalToken(): void {
  localStorage.removeItem('token');
  notifySiblingAuth(null);
}
